import { projectRings } from "../geotools";
import { Polygon } from "./Polygon";
/**
 * H3 polygon with one or more contours (rings). Coordinates in the contours must not be enclosed (first and last points must not be same).
 * @alias sGis.feature.H3Grid
 */
export class H3Feature extends Polygon {
    /**
     * Returns a copy of the feature. Only generic properties are copied.
     */
    clone() {
        return new H3Feature(this.rings, { crs: this.crs, symbol: this.originalSymbol });
    }
    projectTo(crs) {
        let projected = projectRings(this.rings, this.crs, crs);
        return new H3Feature(projected, { crs: this.crs, symbol: this.symbol, persistOnMap: this.persistOnMap });
    }
}
